import { createContext, useContext, useCallback } from 'react';

const CurrencyContext = createContext(null);

export function CurrencyProvider({ children }) {
  const formatPrice = useCallback((usdAmount) => {
    const amt = parseFloat(usdAmount);
    if (isNaN(amt)) return '';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amt);
  }, []);

  return (
    <CurrencyContext.Provider value={{ currency: 'USD', setCurrency: () => {}, rates: { USD: 1 }, formatPrice, isUSD: true }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  const ctx = useContext(CurrencyContext);
  if (!ctx) throw new Error('useCurrency must be used inside CurrencyProvider');
  return ctx;
}

// Keep export so Nav.jsx import doesn't break — empty array removes picker options
export const SUPPORTED_CURRENCIES = [];
